import { Loader } from "@googlemaps/js-api-loader"

export default class Maps {
    constructor () {

       this.maps = document.getElementById('map');

    }

    init() {
        if(this.maps) { this.map(); }
    }
    
    map = () => {
        var lat = this.maps.getAttribute('data-lat');
        console.log('latitudine: '+ lat)
        var lng = this.maps.getAttribute('data-lng');
        console.log('longitudine: '+ lng)
        var map = new google.maps.Map(this.maps, {
            zoom: 16,
            center: {
              lat: Number(lat),
              lng: Number(lng)
            },
            mapTypeId: google.maps.MapTypeId.ROADMAP
        });
        new google.maps.Marker({
            position: {
                lat: Number(lat),
                lng: Number(lng)
            },
            map,
        });      
    }
}